export function truncate(str, max = 36) { // eslint-disable-line
  const s = String(str);
  return s.length > max ? `${s.substr(0, max)}...` : s;
}
